import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { countriesApi } from '../../api/endpoints/countries';

interface CountrySelectProps {
  value?: number | null;
  onChange?: (value: number | null) => void;
  placeholder?: string;
}

/** Select de países (catálogo de la tabla Country). */
export function CountrySelect({ value, onChange, placeholder }: CountrySelectProps): JSX.Element {
  const { data, isLoading } = useQuery({
    queryKey: ['countries'],
    queryFn: () => countriesApi.list(),
    staleTime: 60 * 60_000,
  });

  return (
    <Select
      showSearch
      allowClear
      loading={isLoading}
      value={value ?? undefined}
      onChange={(v) => onChange?.(v ?? null)}
      placeholder={placeholder ?? 'País…'}
      optionFilterProp="label"
      options={(data ?? []).map((c) => ({ value: c.id, label: c.name }))}
      style={{ width: '100%' }}
    />
  );
}
